export const SingleStakeLimits = 2000000000;
export const SystemStakeLimits = 2000000000;

export const ticketErrorConstants = {
  code_51931: {
    code: "51931",
    message: "No está permitido combinar pronósticos del mismo mercado.",
  },
  code_51937: {
    code: "51937",
    message: "La cuota ha cambiado.",
  },
  code_51941: {
    code: "51941",
    message: "Selección bloqueada.",
  },
  code_51927: {
    code: "51927",
    message: "Mercado no disponible.",
  },
  ST_BS_ToLowMinAmountPerWay: {
    code: "ST_BS_ToLowMinAmountPerWay",
    message: "ST_BS_ToLowMinAmountPerWay",
  },
  multiError: {
    code: "multiError",
    message: "No está permitido este tipo de apuesta.",
  },
  ST_EMS_ErrorOddsChangeUp: {
    code: "ST_EMS_ErrorOddsChangeUp",
    message: "ST_EMS_ErrorOddsChangeUp",
  },
  ST_EMS_ErrorOddsChangeDown: {
    code: "ST_EMS_ErrorOddsChangeDown",
    message: "ST_EMS_ErrorOddsChangeDown",
  },
  ST_SBS_CalculationBaseInvalidOdd: {
    code: "ST_SBS_CalculationBaseInvalidOdd",
    message: "ST_SBS_CalculationBaseInvalidOdd",
  },
  ST_SBS_EventNodeNotActive: {
    code: "ST_SBS_CalculationBaseReferenceEventNodeNotActive",
    message: "Mercado no disponible",
  },
  code_9999999: {
    code: "9999999",
    message: "PlayerErrorMessage",
  },
  NationalBetError: {
    code: "NationalBetTypeNotAllowed",
    message: "NationalBetTypeNotAllowed",
  },
};

export enum TicketItemTypesEnum {
  LINE_ITEM = "LineItems",
  STRAIGHT = "StraightM",
  COMBINATION = "CombinationMulticast",
  SMARTMARKET = "SmartLineItems",
}

export enum BetslipItemTypesEnum {
  LINE_ITEM = "singleResultItems",
  STRAIGHT = "straightMulticastItems",
  COMBINATION = "combinationMulticastItems",
  SMARTMARKET = "smartMarketItems",
}
